import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import ConfigIndex from './ConfigIndex.vue';
import RoomsIndex from './RoomsIndex.vue';
import RatesIndex from './RatesIndex.vue';
import ExtrasIndex from './ExtrasIndex.vue';
import RoomRatesIndex from './RoomRatesIndex.vue';
import BookingsIndex from './BookingsIndex.vue';
import CalendarIndex from './CalendarIndex.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/motor-reserva'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'motor_reserva_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'motor_reserva_config', params: to.params };
          },
        },
        {
          path: 'config',
          name: 'motor_reserva_config',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'config' } },
        },
        {
          path: 'rooms',
          name: 'motor_reserva_rooms',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'rooms' } },
        },
        {
          path: 'rates',
          name: 'motor_reserva_rates',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'rates' } },
        },
        {
          path: 'extras',
          name: 'motor_reserva_extras',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'extras' } },
        },
        {
          path: 'room-rates',
          name: 'motor_reserva_room_rates',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'room-rates' } },
        },
        {
          path: 'calendar',
          name: 'motor_reserva_calendar',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'calendar' } },
        },
        {
          path: 'bookings',
          name: 'motor_reserva_bookings',
          meta: {
            permissions: ['administrator'],
          },
          components: {
            default: Index,
          },
          props: { default: { activeTab: 'bookings' } },
        },
      ],
    },
  ],
};
